import gsap from 'gsap';

// https://greensock.com/docs/v3/GSAP/gsap.quickSetter()
// https://greensock.com/forums/topic/19789-follow-by-mouse/

const dotCursor = () => {

  // gsap.set(".cursor", { xPercent: -50, yPercent: -50 });

  // const cursor = document.querySelector(".cursor");
  // const link = document.querySelectorAll('a, .btn, input[type="submit"], #hamburger');
  // const lite = document.querySelectorAll('.site-footer, .page-template-page--contact');

  // const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  // const mouse = { x: pos.x, y: pos.y };
  // const speed = 1; // 0.1
  // const xSet = gsap.quickSetter(cursor, "x", "px");
  // const ySet = gsap.quickSetter(cursor, "y", "px");

  // window.addEventListener("mousemove", e => {
  //   mouse.x = e.x;
  //   mouse.y = e.y;
  // });

  // gsap.ticker.add(() => {
  //   pos.x += (mouse.x - pos.x) * speed;
  //   pos.y += (mouse.y - pos.y) * speed;
  //   xSet(pos.x);
  //   ySet(pos.y);
  // });

  // // Animate for links and buttons
  // link.forEach(e => {
  //   // Enter
  //   e.addEventListener("mouseenter", function () {
  //     cursor.classList.add("is-active");
  //   });
  //   // leave
  //   e.addEventListener("mouseleave", function () {
  //     cursor.classList.remove("is-active");
  //   });
  // });

  // // Lite variations 
  // lite.forEach(e => {
  //   // Enter
  //   e.addEventListener("mouseenter", () => {
  //     cursor.classList.add("is-active--lite");
  //   });
  //   // leave
  //   e.addEventListener("mouseleave", () => {
  //     cursor.classList.remove("is-active--lite");
  //   });
  // });

}

export default dotCursor;